<template>
  <div class="bg-[#F7F8FB] p-4 rounded-md space-y-8 mt-6 sm:mt-8">
    <div v-for="(author, i) in authorInformation" :key="i" class="relative">
      <div class="flex flex-row items-center">
        <div class="flex flex-row flex-shrink-0">
          <OLink pure :href="author.url" class="inline-block overflow-hidden" v-bind="{ target: '_blank' }" @click="handleClickProfile">
            <OAvatar :src="author.image" :alt="author.name" class="w-12 h-12" :rounded="true" />
          </OLink>
        </div>
        <div class="flex-1 flex-col text-sm ml-3 overflow-hidden">
          <div class="flex" :class="[isMobile ? 'flex-col' : 'flex-row']">
            <OLink pure :href="author.url" v-bind="{ target: '_blank' }" @click="handleClickProfile">
              <div class="text-primary-200 font-bold">{{ author.name || author.username || PASSIVE_USER }}</div>
              <div class="text-primary-300 font-normal">{{ author.title }}</div>
            </OLink>
          </div>
        </div>
      </div>

      <div class="text-primary-200 font-normal text-sm mt-3">{{ author.sideText }}</div>
      <!-- go to profile -->
      <OLink
        pure
        class="
          bg-[#E2E5ED]
          rounded-md
          u-center
          h-[34px]
          mt-3
          w-full
          sm:w-[119px]
          text-primary-100
          hover:text-link-primary
          sm:absolute sm:right-0 sm:top-0 sm:mt-0
        "
        :href="author.url"
        v-bind="{ target: '_blank' }"
        @click="handleClickProfile"
      >
        <div class="font-bold text-sm">Tüm içerikleri</div>
        <OIcon icon="right-dark" />
      </OLink>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, inject } from '@nuxtjs/composition-api';
import { getImageUrl } from '~/modules/common/utils/imageUtils';
import { OAvatar, OLink, OIcon } from '~/modules/common/components/ui';
import { useDevice } from '~/composables/useDevice';
import { getProfileUrl } from '~/modules/common/utils/routingUtils';
import { PASSIVE_USER } from '~/constants/site';
import { onedioEvents } from '~/modules/tracking/scripts/onedioEvents';

export default defineComponent({
  components: {
    OAvatar,
    OLink,
    OIcon,
  },
  setup() {
    const { sendDetayInteractionEvent } = onedioEvents();
    const article = inject('article');
    const { isMobile } = useDevice();
    const authorInformation = computed(() => {
      return article.authors.reduce((acc, author, index) => {
        if (index < 2) {
          acc.push({
            image: getImageUrl(author?.avatar, { width: 50 }),
            url: getProfileUrl({ user: author }),
            name: author?.name,
            username: author?.username,
            title: author?.title,
            sideText: author?.sideText,
          });
        }
        return acc;
      }, []);
    });

    const handleClickProfile = () => {
      sendDetayInteractionEvent('Detay Sayfası', 'Click', 'Künye');
    };

    return { authorInformation, PASSIVE_USER, isMobile, handleClickProfile };
  },
});
</script>
